// §4.4 partial — prints route.
// The prints feature is a dead concept (no v2 API); we render an unavailable
// notice rather than a 404 to give users a clear explanation.
import { lazyWithRetry } from "@/lib/lazy/lazyWithRetry";
import type { RouteObject } from "react-router-dom";

const PrintsPage = lazyWithRetry(() => import("./pages/PrintsPage"));

const routes: RouteObject[] = [{ path: "/prints", Component: PrintsPage }];

export default routes;
